import {
    SkyNetTableField,
    SkyNetTableConfig,
} from 'app/shared-components/SkyNetTable'
import {
    CommonRoutes,
    FilterType,
} from 'app/enums/common.enums'
import {
    LanesDomainRoutes,
} from 'app/enums/domain.enums'
import {
    LeaseType,
    CollectionServiceType,
    DeliveryServiceType,
} from 'app/enums/label.enums'
import requests from 'app/requests/ContractBasis/LaneGroup/Lane/LaneOps.requests'

import {
    LaneOpsOverview,
} from './lanes.types'

import UpcomingLaneOverview from './UpcomingLaneOverview'

const firstGeneralFields: SkyNetTableField<keyof LaneOpsOverview>[] = [
    {
        name: 'laneNumber',
        reduced: true,
    },
    {
        name: 'leaseType',
        filterField: 'leaseType',
        filterType: FilterType.Array,
        componentName: 'EnumValue',
        allowedValuesEnum: LeaseType,
    },
]

const customerExecutionFields: SkyNetTableField<keyof LaneOpsOverview>[] = [{
    name: 'customerExecutionLocationName',
    filterField: 'customerExecutionLocationName',
    filterType: FilterType.Array,
    reduced: true,
    labelKey: 'customerExecution',
}]

const customerQuotationField: SkyNetTableField<keyof LaneOpsOverview>[] = [{
    name: 'customerQuotationLocationName',
    filterField: 'customerQuotationLocationName',
    filterType: FilterType.Array,
    labelKey: 'customerQuotation',
}]

const airportFields: SkyNetTableField<keyof LaneOpsOverview>[] = [
    {
        name: 'originAirportIataCode',
        filterField: 'originAirportIataCode',
        filterType: FilterType.Array,
        labelKey: 'originAirport',
    },
    {
        name: 'destAirportIataCode',
        filterField: 'destAirportIataCode',
        filterType: FilterType.Array,
        labelKey: 'destAirport',
    },
]

const temperatureField: SkyNetTableField<keyof LaneOpsOverview> = {
    name: 'tempRange',
    filterField: 'tempRange',
    filterType: FilterType.Array,
}

const handoverFields: SkyNetTableField<keyof LaneOpsOverview>[] = [
    {
        name: 'handoverPointLocationName',
        filterType: FilterType.Array,
        filterField: 'handoverPointLocationName',
        labelKey: 'handoverPoint',
    },
    {
        name: 'consigneeLocationName',
        filterType: FilterType.Array,
        filterField: 'consigneeLocationName',
        labelKey: 'consignee',
    },
]

const serviceTypeFields: SkyNetTableField<keyof LaneOpsOverview>[] = [
    {
        name: 'deliveryServiceType',
        filterType: FilterType.Array,
        filterField: 'deliveryServiceType',
        componentName: 'EnumValue',
        allowedValuesEnum: DeliveryServiceType,
    },
    {
        name: 'collectionServiceType',
        filterType: FilterType.Array,
        filterField: 'collectionServiceType',
        componentName: 'EnumValue',
        allowedValuesEnum: CollectionServiceType,
    },
]

const validToField: SkyNetTableField<keyof LaneOpsOverview> = {
    name: 'validPricingTo',
    filterField: 'validPricingTo',
    filterType: FilterType.DateRange,
    headerProps: {
        children: 'Valid To',
    },
    componentName: 'LaneDateEnriched',
}

const statusField: SkyNetTableField<keyof LaneOpsOverview> = {
    name: 'laneStatus',
    filterType: FilterType.Array,
    filterField: 'laneStatus',
    componentName: 'LaneStatus',
}

const config: SkyNetTableConfig<keyof LaneOpsOverview> = {
    name: 'OrderManagement.LanesTable',
    tabs: [
        {
            name: 'Operational Lanes',
            url: LanesDomainRoutes.OperationalLanes,
            defaultTab: true,
            customUrl: requests.laneOpsOverview().url,
            fields: [
                ...firstGeneralFields,
                ...customerQuotationField,
                ...customerExecutionFields,
                {
                    name: 'pricingAccountCompanyName',
                    filterField: 'pricingAccountCompanyName',
                    filterType: FilterType.Array,
                    reduced: true,
                    labelKey: 'Prebooking.pricingAccount',
                },
                ...airportFields,
                temperatureField,
                ...handoverFields,
                ...serviceTypeFields,
                validToField,
                statusField,
            ],
        },
        {
            name: 'Upcoming Lanes',
            url: LanesDomainRoutes.UpcomingLanes,
            customUrl: requests.laneOpsUpcoming().url,
            fields: [
                ...firstGeneralFields,
                ...customerExecutionFields,
                {
                    name: 'accountCompanyName',
                    filterField: 'accountCompanyName',
                    filterType: FilterType.Array,
                    reduced: true,
                    labelKey: 'RegionalGroups.accountName',
                },
                ...airportFields,
                temperatureField,
                ...serviceTypeFields,
                statusField,
            ],
            formTabs: [{
                url: CommonRoutes.Overview, // needs to be the same as in LaneRoutes.Overview.route
                label: 'Overview',
                Component: UpcomingLaneOverview,
            }],
        },
    ],
}

export default config
